import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 19 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  fill: "currentColor",
  d: "M3.962 0h11.077A3.447 3.447 0 0 1 18.5 3.462v11.077A3.447 3.447 0 0 1 15.039 18H3.962A3.447 3.447 0 0 1 .5 14.539V3.462A3.447 3.447 0 0 1 3.962 0Zm12.902 1.636H13.59V4.91h3.273V1.636ZM6.866 7.084c.559-.798 1.596-1.357 2.634-1.357 1.038 0 2.075.559 2.634 1.357.4.559.639 1.198.639 1.916 0 1.836-1.517 3.273-3.273 3.273-1.756 0-3.273-1.437-3.273-3.273 0-.718.24-1.357.639-1.916Zm8.274 9.28c.94 0 1.724-.763 1.724-1.678V7.364h-2.742c.235.534.392 1.22.392 1.83 0 2.67-2.272 4.881-5.014 4.881-2.742 0-5.014-2.211-5.014-4.88 0-.611.157-1.297.392-1.831H2.136v7.322c0 .915.784 1.678 1.724 1.678h11.28Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }